(function () {
  if (window.__ND_EXPORT_BRAND_MAP__) return;
  window.__ND_EXPORT_BRAND_MAP__ = true;

  /*
    建議：
    1. logoUrl 請放 Shopify Files 的公開 URL
    2. key 先用 email 最穩
    3. 未命中的帳號就走 default
  */

  window.ND_EXPORT_BRAND_MAP = {
  default: {
    enabled: false,
    companyName: "Neuma Doors",
    logoUrl: "https://cdn.shopify.com/s/files/1/XXXX/XXXX/files/neuma_logo.png",
    filePrefix: "Neuma_Quote",
    emailBrandName: "Neuma Doors"
  },

  tags: {
    "export-brand:neuma": {
      enabled: true,
      logoUrl: "https://cdn.shopify.com/s/files/1/0963/0577/4914/files/neuma_doors_logo.png?v=1773938080"
    },
    "export-brand:millworks": {
      enabled: true,
      logoUrl: "https://cdn.shopify.com/s/files/1/0963/0577/4914/files/New_MSI_SBP_logo.jpg?v=1773944511"
    }
  },
};
})();